export enum FeatureFlagKey {
    'enableFavouriteSampleManagement' = 'enableFavouriteSampleManagement',
    'manageOrderingConfigurations' = 'manageOrderingConfigurations',
    'enableTestPsorting' = 'enableTestPsorting'
}
